import script from "./VueDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./VueDatePicker.vue?vue&type=script&setup=true&lang=js"

export default script